import _has from 'lodash/has';

export const getUtterance = context =>
  _has(context, 'option') ? context.option : context;

export const clearUiComponents = thread => {
  return thread.filter((item, index) => {
    // If it's not a ui_component, keep it
    if (item.type !== 'ui_component') {
      return true;
    }

    // If it's a ui_component and marked to keep visible, keep it
    if (item.keepVisible) {
      return true;
    }

    // If it's a ui_component with ATTACHMENT message type, check next item
    if (item?.message?.type === 'ATTACHMENT') {
      const nextItem = thread[index + 1];
      // Don't filter out if next item is a file with error status
      if (nextItem && nextItem.type === 'file' && nextItem.status === 'error') {
        return true;
      }
    }

    // Otherwise, filter out the ui_component
    return false;
  });
};

const showListComponent = item => {
  const withLinks = item.message?.entries?.some(entry => {
    return entry.options?.some(option => option?.url);
  });

  return item.message?.type === 'VERTICAL_LIST' && withLinks;
};

export const isUiComponentVisible = item => {
  const keepVisible = item.type === 'ui_component' && showListComponent(item);

  return { ...item, keepVisible };
};
